import { z } from 'zod';

/** 全部错误码（前后端共享） */
export const ErrorCodeSchema = z.enum([
  // 入参 / 配置
  'BAD_REQUEST',
  'VALIDATION_FAILED',
  'CONFIG_INCOMPLETE',
  // 资源
  'BATCH_NOT_FOUND',
  'ASSET_NOT_FOUND',
  'CONFIG_NOT_FOUND',
  // 状态
  'BATCH_INVALID_STATE',
  // 外部服务
  'MODEL_PROVIDER_ERROR',
  'STORAGE_ERROR',
  // 鉴权（P1 接入认证后才用）
  'UNAUTHENTICATED',
  'FORBIDDEN',
  // 邀请码 / 额度（Slice 9）
  'INVITE_REQUIRED',
  'INVALID_INVITE',
  'QUOTA_EXCEEDED',
  // 兜底
  'INTERNAL',
]);
export type ErrorCode = z.infer<typeof ErrorCodeSchema>;

/** API 错误响应体（HTTP 4xx/5xx 时返回的 JSON） */
export const ApiErrorResponseSchema = z.object({
  error: z.object({
    code: ErrorCodeSchema,
    message: z.string(),
    /** 可选：字段级校验错误（zod 失败时填） */
    issues: z.array(z.object({
      path: z.array(z.union([z.string(), z.number()])),
      message: z.string(),
    })).optional(),
  }),
});
export type ApiErrorResponse = z.infer<typeof ApiErrorResponseSchema>;

/** 错误码 → HTTP status 默认映射（BFF 中间件用） */
export const ERROR_HTTP_STATUS: Record<ErrorCode, number> = {
  BAD_REQUEST: 400,
  VALIDATION_FAILED: 400,
  CONFIG_INCOMPLETE: 400,
  BATCH_NOT_FOUND: 404,
  ASSET_NOT_FOUND: 404,
  CONFIG_NOT_FOUND: 404,
  BATCH_INVALID_STATE: 409,
  MODEL_PROVIDER_ERROR: 502,
  STORAGE_ERROR: 502,
  UNAUTHENTICATED: 401,
  FORBIDDEN: 403,
  INVITE_REQUIRED: 403,
  INVALID_INVITE: 400,
  QUOTA_EXCEEDED: 402,
  INTERNAL: 500,
};

/** BFF 抛错用 */
export class ApiError extends Error {
  constructor(
    public code: ErrorCode,
    message: string,
    public issues?: ApiErrorResponse['error']['issues'],
  ) {
    super(message);
    this.name = 'ApiError';
  }
  toResponse(): ApiErrorResponse {
    return {
      error: {
        code: this.code,
        message: this.message,
        ...(this.issues ? { issues: this.issues } : {}),
      },
    };
  }
  get httpStatus(): number {
    return ERROR_HTTP_STATUS[this.code];
  }
}
